exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map {\n  height: 340px;\n  width: 90%;\n}\n\n.div-header{\n  margin: 0px !important;\n  padding-top: 15px !important;\n}\n\n.ng-invalid {\n  border-color: red;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/map/map.component.css
// module id = ../../../../../src/app/pages/map/map.component.css
// module chunks = main